var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { ButtonBorderedKVBase, ButtonKVBase, CircleLoader, DefaultModal, SimpleSelectKVBase } from '@/presentation/components';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { manageStudentsAtom } from '../atoms';
import Styles from './modal-checkout-styles.scss';
import { modalCheckoutAtom } from './atoms';
import CostItem from './components/cost-item';
import { IconArrowBack, StripeIcon } from '@/presentation/components/icons';
import { centsFormat } from '@/main/utils/number-utils';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { addStudentsManuallyAtom } from '../modal-add-students-manually/atoms';
const getTaxInfo = (localTaxDescripion, totalTax) => {
    if (totalTax > 0) {
        return {
            description: 'Taxes',
            detail: localTaxDescripion,
            amount: totalTax
        };
    }
    return null;
};
const ModalCheckout = ({ idClient, manageStripe }) => {
    const [manageStudentsState, setManageStudentsState] = useRecoilState(manageStudentsAtom);
    const [state, setState] = useRecoilState(modalCheckoutAtom);
    const resetState = useResetRecoilState(modalCheckoutAtom);
    const resetAddStudentsManuallyState = useResetRecoilState(addStudentsManuallyAtom);
    const [taxDescripion, setTaxDescripion] = useState('');
    const [invoice, setInvoice] = useState(null);
    const [changedPlan, setChangedPlan] = useState({
        upgraded: false,
        downgraded: false
    });
    const { showCustomError, showCustomSuccess, showCustomWarning } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const [btnLoading, setBtnLoading] = useState(false);
    const getSubscriptionProration = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        try {
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            const res = yield manageStripe.subscriptionProration();
            if (res) {
                setState(prev => {
                    var _a, _b, _c;
                    return (Object.assign(Object.assign({}, prev), { plan: (_a = res === null || res === void 0 ? void 0 : res.newBillCalculation) === null || _a === void 0 ? void 0 : _a.plan, items: (_b = res === null || res === void 0 ? void 0 : res.invoice) === null || _b === void 0 ? void 0 : _b.lines.data, total: (_c = res === null || res === void 0 ? void 0 : res.invoice) === null || _c === void 0 ? void 0 : _c.total, isLoading: false }));
                });
                setTaxDescripion(res === null || res === void 0 ? void 0 : res.taxDescripion);
                setInvoice(res === null || res === void 0 ? void 0 : res.invoice);
                setChangedPlan({
                    upgraded: (_a = res === null || res === void 0 ? void 0 : res.newBillCalculation) === null || _a === void 0 ? void 0 : _a.upgraded,
                    downgraded: (_b = res === null || res === void 0 ? void 0 : res.newBillCalculation) === null || _b === void 0 ? void 0 : _b.downgraded
                });
            }
        }
        catch (error) {
            console.error(error);
            if ((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.body) === null || _d === void 0 ? void 0 : _d.description) {
                showCustomError('Error', (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.body) === null || _f === void 0 ? void 0 : _f.description);
            }
        }
    });
    const updateSubscription = () => __awaiter(void 0, void 0, void 0, function* () {
        setBtnLoading(true);
        const res = yield manageStripe.clientUpdateBilling();
        setBtnLoading(false);
        if (res && (res === null || res === void 0 ? void 0 : res.id)) {
            showCustomSuccess('OK', 'Subscription updated!');
            setTimeout(() => showCustomWarning('Student draft status', 'We are currently sending email invitations; this process may take a few seconds.'), 1000);
            setManageStudentsState(prev => (Object.assign(Object.assign({}, prev), { modalCheckoutSuccess: true, modalCheckout: false, reloadStudents: !prev.reloadStudents })));
            resetState();
            resetAddStudentsManuallyState();
        }
        else {
            showCustomError('Error', 'Something went wrong!');
        }
    });
    useEffect(() => {
        if (idClient)
            getSubscriptionProration();
    }, [idClient]);
    const simpleItems = Array.isArray(state === null || state === void 0 ? void 0 : state.items) ? state.items : [];
    const taxInfo = getTaxInfo(taxDescripion, (invoice === null || invoice === void 0 ? void 0 : invoice.tax) || 0);
    const [timeExpired, setTimeExpired] = useState(false);
    const clearStudents = () => __awaiter(void 0, void 0, void 0, function* () {
        setBtnLoading(true);
        yield manageStripe.deleteDraftStudentsFromClient().then(console.log).catch(console.error);
        setBtnLoading(false);
        setManageStudentsState(prev => (Object.assign(Object.assign({}, prev), { modalCheckout: false })));
    });
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            clearStudents();
            setTimeExpired(true);
            // setTimeout(() => window.location.reload(), 1000);
            e.returnValue = 'Are you sure you want to leave?';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(DefaultModal, { height: "95", hUnit: "%", width: "90", wUnit: "%", open: manageStudentsState.modalCheckout, overlayCustomStyles: { zIndex: 9999 }, contentCustomStyles: { padding: 25 } },
            React.createElement("div", { className: Styles.wrap },
                React.createElement("div", { className: Styles.content, "data-testid": `payment-info-content` },
                    React.createElement("h1", { className: Styles.title }, "Payment Information"),
                    React.createElement("div", { className: Styles.text },
                        React.createElement(SimpleSelectKVBase, { name: 'suscriptionId', label: 'SUBSCRIPTION PLAN', required: true, defaultValue: 'individual', disabled: true },
                            React.createElement("option", { value: "" }, state.plan))),
                    changedPlan.upgraded && (React.createElement("div", { className: Styles.upgraded },
                        React.createElement("span", null,
                            "Your account is going to be upgraded to ",
                            React.createElement("b", null, "Schools & Beyond"),
                            " due to the number of students"))),
                    changedPlan.downgraded && (React.createElement("div", { className: Styles.upgraded },
                        React.createElement("span", null,
                            "Your account is going to be downgraded to ",
                            React.createElement("b", null, "Family & Friends"),
                            " due to the number of students"))),
                    React.createElement("hr", { className: Styles.divider }),
                    React.createElement("div", { className: `accordion ${state.isLoading && 'd-none'}`, id: "accordionExample" },
                        React.createElement("div", { className: "accordion-item" },
                            React.createElement("h2", { className: "accordion-header", id: "headingOne" },
                                React.createElement("button", { className: "accordion-button collapsed", type: "button", "data-bs-toggle": "collapse", "data-bs-target": "#collapseOne", "aria-expanded": "true", "aria-controls": "collapseOne" }, "Line item details")),
                            React.createElement("div", { id: "collapseOne", className: "accordion-collapse collapse ", "aria-labelledby": "headingOne", "data-bs-parent": "#accordionExample" },
                                React.createElement("div", { className: "accordion-body" },
                                    React.createElement("div", { className: Styles.costs },
                                        React.createElement("div", { className: Styles.costsBody }, simpleItems &&
                                            simpleItems.map((item, index) => {
                                                var _a;
                                                return (React.createElement(CostItem, { key: index, title: item === null || item === void 0 ? void 0 : item.description, cost: `${centsFormat(item === null || item === void 0 ? void 0 : item.amount)}`, students: (item === null || item === void 0 ? void 0 : item.description) === 'Taxes'
                                                        ? item === null || item === void 0 ? void 0 : item.detail
                                                        : `${item === null || item === void 0 ? void 0 : item.quantity} Students - ${(_a = item === null || item === void 0 ? void 0 : item.price) === null || _a === void 0 ? void 0 : _a.nickname}` }));
                                            }))))))),
                    React.createElement("hr", { className: Styles.divider }),
                    state.isLoading ? (React.createElement("div", { className: Styles.intLoader },
                        React.createElement(CircleLoader, null))) : (React.createElement("div", { className: Styles.costs },
                        React.createElement("div", { className: Styles.costsBody }, taxInfo && (React.createElement(React.Fragment, null,
                            React.createElement(CostItem, { title: taxInfo === null || taxInfo === void 0 ? void 0 : taxInfo.description, cost: `${centsFormat(taxInfo === null || taxInfo === void 0 ? void 0 : taxInfo.amount)}`, students: taxInfo === null || taxInfo === void 0 ? void 0 : taxInfo.detail }),
                            React.createElement(CostItem, { title: 'Subtotal', cost: `${centsFormat(invoice === null || invoice === void 0 ? void 0 : invoice.subtotal_excluding_tax)}`, students: 'subtotal excluding taxes' })))),
                        !state.isLoading && (React.createElement("div", { className: Styles.total },
                            React.createElement("span", { className: Styles.totalTitleText }, "Total"),
                            React.createElement("span", { className: Styles.totalValue },
                                "$",
                                centsFormat(state.total)))))),
                    React.createElement("hr", { className: Styles.divider }),
                    React.createElement("div", { className: "d-flex justify-content-around" },
                        React.createElement("div", { style: { width: 'fit-content' } },
                            React.createElement(ButtonBorderedKVBase, { type: "button", color: "black", leftIcon: React.createElement(IconArrowBack, null), onClick: clearStudents, loading: btnLoading, leftIconClass: Styles.leftIconClass }, "Back")),
                        React.createElement("div", null,
                            React.createElement(ButtonKVBase, { type: 'button', onClick: updateSubscription, className: Styles.submitButton, btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", testId: "continue-button", disabled: (state === null || state === void 0 ? void 0 : state.items.length) < 1 || timeExpired || manageStudentsState.totalStudentsCreated < 1, loading: btnLoading }, changedPlan.upgraded ? 'Confirm upgrade' : changedPlan.downgraded ? 'Confirm downgrade' : 'Confirm'),
                            timeExpired && React.createElement("small", { style: { color: 'red' } }, "Time expired"))),
                    React.createElement("div", { className: Styles.stripeMessage },
                        React.createElement("h4", null, "* Additional fees may apply"),
                        React.createElement("h4", null, "** By continuing you will be redirect to the Stripe payment page."),
                        React.createElement("div", { className: Styles.stripe },
                            React.createElement("span", null, "Secured by"),
                            React.createElement("span", { className: Styles.logo },
                                React.createElement(StripeIcon, null)))))))));
};
export default ModalCheckout;
